import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import useAuth from ".";
import LinkButton from "../ui/button/LinkButton";

function NotLoggedIn() {
  const { doLoginWithAppleSignin, doLoginWithGoogleSignin } = useAuth();
  return (
    <div style={{ flex: 1 }}>
      <Fragment>
        <h3>
          <FormattedMessage id={"myFlow.login"} />
        </h3>
        <p>
          <FormattedMessage id={"myFlow.loginInstruction"} />
        </p>
      </Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexGrow: 1,
        }}
      >
        <LinkButton
          label={<FormattedMessage id={"myFlow.googleLogin"} />}
          onClick={doLoginWithGoogleSignin}
          buttonClassName="google-signin"
        />
        <LinkButton
          label={<FormattedMessage id={"myFlow.appleLogin"} />}
          onClick={doLoginWithAppleSignin}
          buttonClassName="apple-signin"
        />
      </div>
    </div>
  );
}

export default function InfoBox() {
  const { user } = useAuth();
  if (!user) {
    return <NotLoggedIn />;
  }

  return (
    <div style={{ flexDirection: "row" }}>
      <Fragment>
        <h3>
          <FormattedMessage id={"strings.hi"} />
          {user.displayName ? " " + user.displayName : ""}!
        </h3>
      </Fragment>
    </div>
  );
}



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/auth/InfoBox.tsx